<wiz-hgroup #argContainer wizValidationContainer width="100%" height="100%">
  
  <!-- drop pour les valeurs de key / filter -->
  <!-- drop pour les chronos -->
   <!-- drop pour les crossVision -->
  <form-drop-extended-renderer
  #ddext *ngIf="useddext"
  width="100%"
  [manageModel] = false
  [wizShowLabel]="showLabel"
  [wizMandatory]="wizmandatory"
  [wizDisabled]="wizdisabled"
  [data]="formatedValue"
  [ngClass]="injectClass"
  ></form-drop-extended-renderer>

  <!-- rendu séquence -->
  <wiz-hgroup #seqGP *ngIf="useSeqGP" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-label class="componentLabel" id="label"
      [wizLabel]="componentlabel"
      [visible]="showLabel"></wiz-label>
      <wiz-hgroup width="100%" verticalAlign="center" id="inzone">
        <wiz-icon style="font-size: 24px;">wizeoo</wiz-icon>
        <div innerHTML="{{ formatedValue }}"></div>
      </wiz-hgroup>
    </wiz-vgroup>  
  </wiz-hgroup>



  <!-- rendu type commentaire -->
  <wiz-text-area
    #ta *ngIf="useta"
    [wizLabel]="componentlabel"
    [wizMaxChars]="wizmax"
    [wizValue]="formatedValue"
    [wizRestrict]="forceRestrict"
    [wizValidator]="checkValueIntegrity()"
    width="100%"
    height="100%"
    [ngClass]="injectClass"
    [wizShowLabel]="showLabel">
  </wiz-text-area>

  <wiz-text-input
    #ti *ngIf="useti"
    [wizValidator]="checkValueIntegrity()"
    wizFocusMode="PASS"
    wizShowErrors="true"
    width="100%"
    [wizMaxChars]="wizmax"
    [wizValue]="formatedValue"
    [wizRestrict]="forceRestrict"
    [ngClass]="[forceCaps, injectClass]"
    [wizLabel]="componentlabel"
    [wizShowLabel]="showLabel"></wiz-text-input>

  <wiz-numeric-input
    #ni *ngIf="useni"
    [wizLabel]="componentlabel"
    [wizMaxChars]="20"
    wizShowErrors="true"
    width="100%"
    wizFocusMode="PASS"
    [nbDecimal]="decimal"
    [wizMinNumber]="wizmin"
    [wizMaxNumber]="wizmax"
    [wizNumber]="formatedValue"
    [wizValidator]="checkValueIntegrity()"
    [ngClass]="injectClass"
    (wizKey)="fastChange($event)"
    [wizShowLabel]="showLabel"></wiz-numeric-input>

  <wiz-datefield #da *ngIf="useda"
    [wizLabel]="componentlabel"
    [wizNumberValue]="formatedValue"
    [wizMinDate]="wizmin"
    [wizMaxDate]="wizmax"
    [wizValidator]="checkValueIntegrity()"
    wizShowErrors="true" width="100%" 
    wizFocusMode="PASS"
    [ngClass]="injectClass"
    (wizKey)="fastChange($event)"
    [wizShowLabel]="showLabel"></wiz-datefield>

  <wiz-checkbox #cb *ngIf="usecb" 
    [wizTriStateMode]="false" 
    [wizLabel]="componentlabel"
    [wizChecked]="formatedValue"
    [ngClass]="injectClass"
    [wizShowLabel]="showLabel"></wiz-checkbox>
  
  <wiz-group #imgGp *ngIf="useimgGp" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass" width="100%" height="100%">
      <wiz-label #imgLbl id="label" 
      [wizLabel]="componentlabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
      <wiz-vgroup gap="0" width="100%" height="100%" horizontalAlign="center" verticalAlign="center">
        <wiz-image
          #img
          tabIndex="0"
          height="100%"
          width="100%"
          [blobid]="imgBlobid"
          [sourceObservable]="imgSrcObs"
          class="img-picker img-freestyle" 
          [useHandCursor]="true"
          wizholdable
          (wizTap)="clickForUpload($event)"
          (wizHold)="clickForUpload($event)"
          (keydown)="keydownForUpload($event)"    
          ></wiz-image>
      </wiz-vgroup>

    </wiz-vgroup>
    <wiz-hgroup width="100%" horizontalAlign="end">
      <wiz-icon
      [visible]="hasImage && !readOnly"
      style="cursor: pointer; font-size: 20px"
      (click)="clearImage()"
      [wizTooltip]="'$.common.delete.$'"
      >delete</wiz-icon>
    </wiz-hgroup>
  </wiz-group>

  <wiz-button #bt *ngIf="usebt" 
  class="button-connect"
  [wizLabel]="cnx?.trsLabel"
  [tooltipText]="cnx?.trsDescription"
  [wizImage]="cnx?.iconOrDie"
  width="100%" (wizClick)="doArgAction()"></wiz-button>

  <!-- rendu liste de sous-éléments -->
  <wiz-hgroup #listGP *ngIf="uselistGP" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-hgroup width="100%">
        <wiz-label #listLbl class="componentLabel" id="label" width="100%" 
        [wizLabel]="componentlabel"
        [visible]="showLabel"></wiz-label>
        <i #icoList id="ico" 
        class="wiz-icon- cell-edit-icon" 
        style="font-size: 18px; cursor: pointer"
        (click)="showListPop($event)">edit</i>
      </wiz-hgroup>

      <div innerHTML="{{ formatedValue }}" id="inzone"></div>
    </wiz-vgroup>  
  </wiz-hgroup>

  <!-- html libre -->
  <wiz-hgroup #freeGrp *ngIf="usefreeGrp" [visible]="readyfreeGrp" width="100%" height="100%">
    <angular-editor #ae 
    width="100%" height="100%" style="pointer-events: none;"></angular-editor>
  </wiz-hgroup>

  <wiz-hgroup #freeImgGrp *ngIf="usefreeImgGrp" [ngClass]="injectClass" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [sourceObservable]="imgSrcObs"
        #freeImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <!-- rendu lien hypertexte sur un texte -->
  <wiz-hgroup #linkGp  *ngIf="uselinkGp" width="100%" height="100%">
    <div><a href="{{linkUrl}}" target="_blank">{{linkLabel}}</a></div>
  </wiz-hgroup>

  <!-- rendu de type "media" sur un texte -->
  <wiz-hgroup #mediaGrp *ngIf="usemedia" width="100%" height="100%">
    <wiz-image
        class="img-freestyle"
        [source]="formatedValue"
        #mediaImg
        tabindex="0"
        height="100%"
        width="100%"></wiz-image>
  </wiz-hgroup>

  <wiz-vgroup *ngIf="usecolor" width="100%" height="100%" [ngClass]="injectClass">
    <wiz-label #colorLbl  
    [wizLabel]="componentlabel" id="label"
    class="componentLabel" 
    [visible]="showLabel"></wiz-label>
    <wiz-hgroup>
      <span
        #cellBlockBack
        [style.backgroundColor]="formatedValue"
        [style.cursor]="colorCursor"
        width="20px"
        height="20px"
        (click)="showColorPicker($event)"
        style="border-radius: 20px; border-style: solid; border-width: 1px"
      ></span>
      <wiz-icon *ngIf="!this.checkValueDisabled(null)"
      style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockBack')">removal</wiz-icon>
    </wiz-hgroup>
  </wiz-vgroup>

  <!-- zone de drop -->
  <wiz-vgroup *ngIf="useDropGrp" width="100%" height="100%" [ngClass]="injectClass">
    <wiz-label #colorLbl id="label" 
    [wizLabel]="componentlabel"
    class="componentLabel" 
    [visible]="showLabel"></wiz-label>

    <wiz-group #dropGrp *ngIf="useDropGrp" width="100%" height="100%">
      <wiz-vgroup #dropEmpty class="dropZone" *ngIf="!dropFull"
        width="100%" height="100%" horizontalAlign="center" verticalAlign="center" (click)="selectFile()" (drop)="dropFileV2($event)">
        <wiz-icon #icoAddFile [wizTooltip]="'$.common.import.$'">upload</wiz-icon>
        <wiz-label wizLabel="$.common.free.drop.message.$"></wiz-label>
      </wiz-vgroup>
      
      <wiz-hgroup #dropFull class="dropZone" *ngIf="dropFull" 
      horizontalAlign="center" verticalAlign="center" style="padding: 5px;"
      width="100%" height="100%">
        <wiz-label [wizLabel]="mediaReference?.fileName" [wizTooltip]="mediaReference.fileName" width="100%"
        style="word-break: break-all;"></wiz-label>
        <wiz-vgroup width="28px">
          <wiz-icon #icoDelFile
          style="cursor: pointer; font-size: 20px"
          [visible]="!readOnly"
          (click)="clearDropFile()"
          [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>
          <wiz-icon #icoLoadFile [undisableable]="true" style="cursor: pointer; font-size: 20px" (click)="loadDropFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
        </wiz-vgroup>
      </wiz-hgroup>
    </wiz-group>
  </wiz-vgroup>

  <!-- workflow -->
  <wiz-vgroup #workflowGroup *ngIf="useworkflow" width="100%" height="100%" [ngClass]="injectClass">
      <wiz-label #colorLbl id="label" 
      [wizLabel]="componentlabel"
      class="componentLabel" 
      [visible]="showLabel"></wiz-label>
    <wiz-hgroup width="100%" height="100%" id="inzone"
      verticalAlign="center">
      <wiz-image *ngIf="!!workImageBlob"
        class="img-freestyle"
        [sourceObservable]="workImage"
        #workImg
        tabindex="0"
        height="90%"
        style="aspect-ratio: 1;"
        ></wiz-image>
      
      <wiz-icon class="image-purple" *ngIf="!!workIcon">
          <mat-icon>{{workIcon}}</mat-icon></wiz-icon>
        
         <wiz-vgroup width="100%" height="100%" horizontalAlign="center" verticalAlign="center">     
          <wiz-hgroup width="100%" verticalAlign="center" style="overflow-y: auto;">
              <span class="wiz-cell-text" >{{workflowLabel}}</span>
          </wiz-hgroup>  

          <!-- pièce jointe -->
          <wiz-hgroup #dropFull class="dropZone" *ngIf="workFile" 
                horizontalAlign="center" verticalAlign="center" style="padding: 5px;"
                width="100%" height="30px">
                  <wiz-label [wizLabel]="workFile?.shortFileName" [wizTooltip]="workFile.fileName" width="100%"
                  style="word-break: break-all;"></wiz-label>
                  <wiz-vgroup width="28px">  
                    <wiz-icon #icoLoadWorkFile 
                    [undisableable]="true"
                    style="cursor: pointer; font-size: 20px" (click)="loadDropWorkFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
                  </wiz-vgroup>
                </wiz-hgroup>
        
         </wiz-vgroup>
          <wiz-icon 
        [visible] = !argContainer?.wizDisabled
        class="image-purple" (click)="showWorkflow($event)">edit</wiz-icon>
    </wiz-hgroup>
  </wiz-vgroup>

  <!-- container -->
  <wiz-vgroup #freeZone *ngIf="usefreeZone" width="100%" height="100%" gap="-10">
    
    <ng-container #gridInjector *ngIf="useSubGrid" style="width: 100%; height: 100%;"></ng-container>
    <wiz-hgroup *ngIf="!useSubGrid" width="100%" height="100%" verticalAlign="center" style="border-bottom-style: solid; border-width: 1px; border-color: #e9e9e9;" [ngClass]="injectClass">
      <wiz-icon #icoZone id="label"
        style="cursor: pointer; font-size: 20px"
        (click)="showHideZone()"
        [wizTooltip]="freezonelabel">
        {{freezoneicon}}</wiz-icon>
      
        <wiz-label #freeZoneLbl id="label" width="100%"
        [wizLabel]="componentlabel"
        class="componentLabel"></wiz-label>
    </wiz-hgroup>
  </wiz-vgroup>

  <!-- rendu threshold -->
  <wiz-hgroup #thresholdGP *ngIf="usethresholdGP" width="100%" height="100%">
    <wiz-vgroup gap="0" [ngClass]="injectClass">
      <wiz-hgroup width="100%">
        <wiz-label #listLbl class="componentLabel" id="label" width="100%" 
        [wizLabel]="componentlabel"
        [visible]="showLabel"></wiz-label>
        <i #icoThreshold id="ico" 
        class="wiz-icon- cell-edit-icon" 
        style="font-size: 18px; cursor: pointer"
        (click)="showThresholdPop($event)">edit</i>
      </wiz-hgroup>

      <div innerHTML="{{ formatedValue }}" id="inzone"></div>
    </wiz-vgroup>  
  </wiz-hgroup>


</wiz-hgroup>